import React from "react";
export const NumberedSwipeCard_AppDownload = (props) => (React.createElement("div", { className: "numbered-swipe-card--app-download" },
    React.createElement("div", { className: "numbered-swipe-card--app-download__desktop" },
        React.createElement("p", null, props.desktopText),
        React.createElement("img", { src: props.desktopImageUrl, alt: props.desktopImageAlt })),
    React.createElement("div", { className: "numbered-swipe-card--app-download__mobile" },
        React.createElement("p", null, props.mobileText),
        props.mobileDownloadLinks.map(({ imageUrl, linkUrl, imageAlt }, index) => (React.createElement("a", { key: index, href: linkUrl, rel: "noopener" },
            React.createElement("img", { src: imageUrl, alt: imageAlt })))))));
